import baseRoute from '../baseRoute';

type RouteDefinition = `${typeof baseRoute}/phoneFinalize`;

export const ROUTE: RouteDefinition = `${baseRoute}/phoneFinalize`;

export const URL = (): RouteDefinition => `${baseRoute}/phoneFinalize`;
